export let sprintf = new (function() {
  let f = [
      "toString",
      "toUpperCase",
      "toLowerCase",
      "toFixed",
      "toExponential",
      "toPrecision",
      "fromCharCode",
      "length"
    ],
    formats = {
      "%": function(v) {
        return "%";
      },
      b: function(v) {
        return (+v)[f[0]](2);
      },
      c: function(v) {
        return String[f[6]](+v);
      },
      C: function(v) {
        return String[f[6]](+v)[f[1]]();
      },
      d: function(v) {
        return +v ? +v : 0;
      },
      e: function(v) {
        return (+v)[f[4]]()[f[0]]();
      },
      E: function(v) {
        return (+v)[f[4]]()[f[1]]();
      },
      f: function(v, p) {
        return (+v)[f[3]](p);
      },
      F: function(v, p) {
        return (+v)[f[3]](p);
      },
      g: function(v, p) {
        return ((+v)[f[5]](p)[f[0]]()[f[7]] < (+v)[f[4]]()[f[0]]()[f[7]]
          ? (+v)[f[5]](p)
          : (+v)[f[4]]())[f[0]]();
      },
      G: function(v, p) {
        return ((+v)[f[5]](p)[f[0]]()[f[7]] < (+v)[f[4]]()[f[0]]()[f[7]]
          ? (+v)[f[5]](p)
          : (+v)[f[4]]())[f[1]]();
      },
      o: function(v) {
        return (+v)[f[0]](8);
      },
      s: function(v) {
        return ("" + v)[f[0]]();
      },
      S: function(v) {
        return ("" + v)[f[1]]();
      },
      u: function(v) {
        return Math.abs(+v);
      },
      x: function(v) {
        return (+v)[f[0]](16)[f[2]]();
      },
      X: function(v) {
        return (+v)[f[0]](16)[f[1]]();
      }
    },
    format = function(d) {
      let i = 0;
      return function(m, a, b, s, w, p, n, f) {
        let r =
          "" +
          formats[f](
            typeof d[i] == "object"
              ? d[d.length == 1 ? i : i++][n]
              : d[d.length == 1 ? i : i++],
            p
          );
        if (r == "%" && d.length != 1) i--;
        if (a) b = a;
        while (b && b.length && r.length < +w) r = s == "-" ? r + b : b + r;
        return r;
      };
    },
    re = new RegExp(
      "%(?:(?:['\"](.)|([0 ]))?([+-])?(\\d+)?(?:\\.(\\d+))?(?:\\(([^)]+)\\))?)([%bcCdeEfFgGosSuxX])",
      "g"
    );
  return function(s) {
    return s.replace(re, format(Array.apply(null, arguments).slice(1)));
  };
})();
